export const ORDER_PRODUCT = `
  mutation orderProduct(
      $order: [OrderProductInput]!
      $email: String!
      $name: String!
      $proxy_name: String
      $zip: String!
      $phone: String!
      $stripe_card_id: String!
      $stripe_token: String!
  ) {
    orderProduct(
      order: $order
      email: $email
      name: $name
      proxy_name: $proxy_name
      zip: $zip
      phone: $phone
      stripe_card_id: $stripe_card_id
      stripe_token: $stripe_token
    ) {
      id
      product_id
      email
      name
      quantity
      error
    }
  }
`